import { UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './DepartmentLink.css';

export interface IDepartmentLinkProps {
  departmentLink: string;
}

export const DepartmentLink: React.FC<IDepartmentLinkProps> = ({ departmentLink }) => {
  return (
    <UIText1>
      Подробнее о рейтинге от дептранса Москвы на{' '}
      <a className={styles['link']} href={departmentLink} target="_blank" rel="noreferrer">
        сайте ведомства
      </a>
    </UIText1>
  );
};
